import { useContext, useEffect, useState } from 'react';
import { WithDataFetcher } from '../../Data/WithDataFetcher';
import { FormContext } from '../FormEngine';
import { getTAFFunds } from '../SpecialRules/TAFSpecialRules';
import SelectInput from './SelectInput';

//takes an onChange prop and calls it with (dataKey, newValue)
const TAFFundSelectInput = props => {
    const { dataKey, data, onChange } = props;
    const { getThenResolver } = props;
    const [funds, setFunds] = useState(null);

    const ctx = useContext(FormContext);

    useEffect(() => {
        async function loadFunds() {
            const funds = await getTAFFunds(getThenResolver, ctx.meta.assistanceProgramId);

            if (funds && funds.length > 0) {
                // find funds based on selected AssistanceService from application wizard
                // filter based on insurance selection
                var filteredFunds = funds
                    .find(f => f.assistanceServiceId === ctx.meta.assistanceServices[0].id).funds
                    .filter(f => {

                        const ins = ctx.formData['Insurance Patient Insurance Types TAF'];
                        return ins ? ins.includes(f.insuranceClassName) : true
                    })
                    .flatMap(f => f.funds);

                var fundOptions = [...new Set(filteredFunds)]
                    .sort((a, b) => a < b ? -1 : 1)
                    .map((fund, idx) => (
                        { key: `${fund}/${idx}`, value: fund, text: fund }
                    ));

                setFunds(fundOptions);
            }
        };

        loadFunds();
        
    }, []);

    const checkValue = value => {
        if (funds) {
            let newValue = value;

            if (!funds.find(o => o.value === value)) {
                newValue = '';
            }
            if (newValue !== data) {
                ctx.specialRuleChangeData('TAF Medication Selection', '');
                onChange(dataKey, newValue);
            }
        }
    }

    useEffect(() => {
        checkValue(data);
        
    }, [funds, data]);

    if (!funds || funds.length === 0) { return null; }

    const myProps = {
        ...props,
        def: {
            ...props.def,
            options: funds.map(f => f.text),
            values: funds.map(f => f.value)
        },
        onChange: (dataKey, value) => {
            checkValue(value);
        },
        name: 'taffundselectinput_de'
    }

    return <SelectInput {...myProps} />
}

export default WithDataFetcher(TAFFundSelectInput);
